import { crudReducer } from "./dataHelper";

const initialState = () => ({
  line_items: []
});

export default crudReducer("line_item", initialState);
